import { useCallback, useMemo, useRef, useState } from 'react'
import { listDutyholderOrganisations, createDutyholderOrganisation } from 'services/dutyholderOrganisationService'

const MAX_PAGES = 8

const useDutyholderOrganisations = () => {
  const [orgs, setOrgs] = useState([])
  const [state, setState] = useState('idle')

  const load = useCallback(async () => {
    setState('loading')
    const collected = []
    try {
      let page = 1
      while (page <= MAX_PAGES) {
        const res = await listDutyholderOrganisations({ page })
        const incoming = res?.data?.data || []
        const meta = res?.data?.meta || {}
        incoming.forEach(o => { if (!collected.some(x => x.id === o.id)) collected.push(o) })
        const lastPage = meta.lastPage || page
        const currentPage = meta.currentPage || page
        if (incoming.length === 0 || currentPage >= lastPage) break
        page = currentPage + 1
      }
      setOrgs(collected)
      setState('loaded')
    } catch (e) {
      setState('error')
    }
  }, [])

  const stateRef = useRef(state)
  stateRef.current = state

  const ensure = useCallback(() => {
    if (stateRef.current === 'idle' || stateRef.current === 'error') load()
  }, [load])

  const create = useCallback(async values => {
    const res = await createDutyholderOrganisation({ ...values, name: values.name.trim() })
    const created = res?.data?.data
    if (!created?.id) throw new Error('Organisation was not returned by the server.')
    setOrgs(prev => (prev.some(o => o.id === created.id) ? prev : [...prev, created]))
    return created
  }, [])

  const options = useMemo(
    () => orgs.map(o => ({ value: o.id, label: o.name, sublabel: o.contactName || undefined })),
    [orgs]
  )

  return { orgs, options, state, load, ensure, create }
}

export default useDutyholderOrganisations
